import { model } from '../paywall/core/model'

const checkInterval = 500;

export const setUserContext = () => {
    const email = model.Usuario.getEmail();

    DD_LOGS.onReady(() => {

        const gaTimeout = setInterval(() => {
            const hasGaId = window.hasOwnProperty('gaId')
            if (hasGaId) {
                console.log(`DDLOG :: context :: email: ${email}, gaId: ${window.gaId}`);
                DD_LOGS.logger.addContext('user.gaId', window.gaId);
                DD_LOGS.logger.addContext('user.email', email);

                clearInterval(gaTimeout);
            }
        }, checkInterval)
    })


    DD_RUM.onReady(() => {

        const gaTimeout = setInterval(() => {
            const hasGaId = window.hasOwnProperty('gaId')
            if (hasGaId) {
                console.log(`DDLOG :: RUM :: email: ${email}, gaId: ${window.gaid}`);
                DD_RUM.setUser({
                    gaId: window.gaId,
                    email: email
                });

                clearInterval(gaTimeout)
            }
        }, checkInterval)

    });

}

export default {
    setUserContext,
}


// WEBPACK FOOTER //
// ./Statics/scripts/common/datadog.js